const isId = (segment) => /^\d+$/.test(segment);

export const describeRoute = (pathname) => {
  const segments = String(pathname || "")
    .split("/")
    .filter(Boolean);
  const ids = segments.filter(isId);
  const page = "/" + segments.filter((segment) => !isId(segment)).join("/");
  return { page, ids };
};

export default describeRoute;
